module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content contact"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "phone-icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "25.980701647306745 25.330692492033307 148.63860280890214 148.63860280890214",
      "role": "img",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M170.5 142.3l-.7-2.1c-1.7-5-7.2-10.2-12.2-11.6l-18.7-5.1c-5.1-1.4-12.3.5-16 4.2l-6.8 6.8c-24.6-6.6-43.8-25.9-50.5-50.5l6.8-6.8c3.7-3.7 5.6-10.9 4.2-16l-5.1-18.7c-1.4-5.1-6.6-10.6-11.6-12.2l-2.1-.7c-5-1.7-12.1 0-15.8 3.7L31.9 43.4c-1.8 1.8-3 6.9-3 7-.4 32.1 12.2 63.1 35 85.8 22.7 22.7 53.5 35.2 85.5 35 .2 0 5.5-1.1 7.3-2.9l10.1-10.1c3.7-3.9 5.3-11 3.7-15.9z"
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("CONTACT US")]), _vm._v(" "), _c('p', [_vm._v("1-833-668-8633")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "address-icon"
  }, [_c('svg', {
    staticStyle: {
      "stroke-width": "10px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "14.155549568042431 23.045053047046338 307.85889903286045 307.85889903286045",
      "role": "img",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M168.085 31.832c4.245-.454 45.943-3.569 84.851 43.417 41.057 49.578 3.873 115.419 3.873 115.419l-88.725 135.018-88.723-135.018s-37.184-65.841 3.873-115.419c38.914-46.986 80.606-43.872 84.851-43.417zm47.415 96.445c0-26.184-21.226-47.409-47.414-47.409-26.184 0-47.414 21.226-47.414 47.409 0 26.189 21.231 47.414 47.414 47.414 26.188 0 47.414-21.225 47.414-47.414z"
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("MAILING ADDRESS")]), _vm._v(" "), _c('p', [_vm._v("Indian Creek Plaza Bricks")]), _vm._v(" "), _c('p', [_vm._v("Fulfillment Center")]), _vm._v(" "), _c('p', [_vm._v("615 E 43rd St., Boise, ID 83714")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "clock-icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "10.981413724129666 10.981420399849881 178.03717255174067 178.03717255174067",
      "role": "img",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M100 13.999c-47.496 0-86 38.504-86 86.001s38.504 86.001 86 86.001 86-38.504 86-86.001-38.504-86.001-86-86.001zM148 114H98a4 4 0 0 1-4-4V48a4 4 0 0 1 8 0v58h46a4 4 0 0 1 0 8z"
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("CONTACT US")]), _vm._v(" "), _c('p', [_vm._v("Monday – Friday: 7:00am – 6:00pm MST")]), _vm._v(" "), _c('p', [_vm._v("Saturday: Closed")]), _vm._v(" "), _c('p', [_vm._v("Sunday: Closed")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-img-wrap"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "980",
      "height": "506",
      "src": "images/contact-bg.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:bricks@indiancreekplaza.com"
    }
  }, [_vm._v("bricks@indiancreekplaza.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d070c2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = /bRb
// module chunks = 1